import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  name: 'Valentina M., 28 años',
  quote: 'Llevaba meses sin poder dormir bien. A la semana de empezar, por primera vez en mucho tiempo, dormí toda la noche sin despertarme con el corazón acelerado. Este sistema me devolvió las noches.'
}, {
  name: 'Lucía R., 34 años',
  quote: 'Yo pensaba que mi ansiedad era parte de mi personalidad. Este método me mostró que no. Hoy puedo estar en silencio sin que mi mente me ataque. Eso no tiene precio.'
}, {
  name: 'Martín G., 31 años',
  quote: 'Lo que más me ayudó fue el bono de relaciones. Entendí por qué me aferraba tanto a las personas y cómo eso alimentaba mi ansiedad. Hoy me siento mucho más seguro conmigo mismo.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-24 bg-beige" data-id="element-116">
      <div className="max-w-6xl mx-auto px-6" data-id="element-117">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-119">
            Historias reales de transformación
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-120"></div>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-121">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-3xl p-8 shadow-sm border border-beige-dark/50 relative" data-id="element-122">
              <div className="absolute top-8 right-8 text-beige-dark opacity-30" data-id="element-123">
                <Quote size={40} data-id="element-124" />
              </div>

              <div className="flex gap-1 mb-6" data-id="element-125">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold text-gold" data-id="element-126" />)}
              </div>

              <p className="text-slate leading-relaxed mb-8 italic relative z-10" data-id="element-127">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-128">
                <div className="w-10 h-10 rounded-full bg-beige flex items-center justify-center text-navy font-serif font-medium" data-id="element-129">
                  {testimonial.name.charAt(0)}
                </div>
                <span className="font-medium text-navy text-sm" data-id="element-130">
                  {testimonial.name}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}